const SystemCapabilitiesEnum = {
    ADMIN: "Admin",
    UPLOAD: "Upload",
    DOWNLOAD: "Download",
    API: "API"
};
  
export default SystemCapabilitiesEnum;